import { BranchSettings, BusinessSettings } from "@/config/constant";
import { __localesModel } from "@/Utils/locales";
const createObj = configModel => {
  const model = {};
  Object.keys(configModel).map(x => (model[x] = null));
  model[BusinessSettings.Locales] = __localesModel;
  return model;
};

export const Models = createObj(BusinessSettings);

export const options = {
  CurrencyOptions: []
};

export const Fields = [
  {
    label: "Business settings",
    type: "spacer",
    line: false,
    xl: "12"
  },
  {
    label: "",
    name: BusinessSettings.Locales,
    placeholder: "Enter your Business Name",
    placeholder2: "About your business",
    type: "localized",
    value: "",
    xl: "6",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "",
    name: BusinessSettings.Logo,
    placeholder: "Upload your Logo",
    type: "file",
    multiple: false,
    value: "",
    xl: "4",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "Contact settings",
    type: "spacer",
    xl: "12",
    line: true
  },
  {
    label: "Phone Number",
    name: BusinessSettings.ContactPhone,
    placeholder: "Enter your contact Phone number",
    // todo:: make it phone
    xl: "6",
    type: "phone"
    // rules: 'phone',
  },
  {
    label: "Whatsapp Number",
    name: BusinessSettings.Whatsapp,
    placeholder: "Enter your Whatsapp number",
    // todo:: make it phone
    xl: "6",
    type: "phone"
    // rules: 'phone',
  },
  {
    label: "Time Zone",
    name: BusinessSettings.TimeZone,
    placeholder: "select your app timezone",
    type: "text",
    value: "",
    xl: "6"
  },
  {
    label: "Address",
    name: BusinessSettings.Address,
    placeholder: "Enter your Address",
    type: "text",
    value: "",
    xl: "6",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "Website",
    name: BusinessSettings.Website,
    placeholder: "Enter your Website url",
    type: "text",
    value: "",
    xl: "6",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "Theme settings",
    type: "spacer",
    xl: "12",
    line: true
  },
  {
    label: "PrimaryColor",
    name: BusinessSettings.PrimaryColor,
    placeholder: "Pic the PrimaryColor",
    type: "color",
    value: "",
    xl: "1",
    validationMessage: {
      required: "This field is required"
    }
  },

  {
    label: "AccentColor",
    name: BusinessSettings.AccentColor,
    placeholder: "Pic the AccentColor",
    type: "color",
    value: "",
    xl: "1",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "TextColor",
    name: BusinessSettings.TextColor,
    placeholder: "Pic the TextColor",
    type: "color",
    value: "",
    xl: "1",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "Social media settings",
    type: "spacer",
    xl: "12",
    line: true
  },
  {
    label: "",
    name: BusinessSettings.X,
    placeholder: "Enter X (Twitter) account URL ",
    type: "text",
    // // rules: 'url',
    xl: "6"
  },
  {
    label: "",
    name: BusinessSettings.Youtube,
    placeholder: "Enter Youtube URL ",
    type: "text",
    // rules: 'url',
    xl: "6"
  },
  {
    label: "",
    name: BusinessSettings.Instagram,
    placeholder: "Enter Instagram account URL ",
    type: "text",
    // rules: 'url',
    xl: "6"
  },
  {
    label: "",
    name: BusinessSettings.Facebook,
    placeholder: "Enter Facebook account URL ",
    type: "text",
    // rules: 'url',
    xl: "6"
  },
  {
    label: "",
    name: BusinessSettings.Snapchat,
    placeholder: "Enter Snapchat URL ",
    type: "text",
    // rules: 'url',
    xl: "6"
  },
  {
    label: "",
    name: BusinessSettings.Linkedin,
    placeholder: "Enter LinkedIn URL ",
    type: "text",
    // rules: 'url',
    xl: "6"
  },
  {
    label: "Price settings",
    type: "spacer",
    xl: "12",
    line: true
  },
  {
    label: "Currency",
    name: BusinessSettings.Currency,
    placeholder: "Select your currency",
    type: "select",
    options: [],
    value: "",
    xl: "2",
    validationMessage: {
      required: "Select type please"
    }
  },
  {
    label: "General Discount %",
    name: BusinessSettings.GeneralDiscount,
    placeholder: "This will be applied for all your items",
    type: "number",
    min: 0,
    max: 100,
    value: "",
    xl: "2",
    // rules: 'gtZero',
    disabled: false
  },
  // {
  //   label: "%",
  //   type: "label",
  //   class: "col-sm-2 pe-1 ps-1 col-lg-1"
  // }
  {
    label: "Extra Charge $",
    name: BusinessSettings.ExtraCharge,
    placeholder: "This will be applied for all your items",
    type: "number",
    min: 0,
    value: "",
    xl: "2",
    // rules: 'gtZero',
    disabled: false
  },
  // TODO:: Change to user's currency
  // {
  //   label: "$",
  //   type: "label",
  //   class: "col-sm-2 pe-1 ps-1 col-lg-1"
  // }
  {
    label: "Preferences",
    type: "spacer",
    xl: "12",
    line: true
  },
  {
    label: "Dine In",
    name: BranchSettings.DineIn,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Delivery",
    name: BranchSettings.Delivery,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Car Pickup",
    name: BranchSettings.CarPickup,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Self Pickup",
    name: BranchSettings.SelfPickUp,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  // {
  //   label: "",
  //   type: "spacer",
  //   line: false
  // }

  {
    label: "Preview Prices",
    name: BusinessSettings.PreviewPrices,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  }
];
